import React, { useState, useCallback } from "react";
import { MoveFocusInside } from "react-focus-lock";
import { Paper, ResizeTransition } from "@activecollab/components";
import classnames from "classnames";
import PropTypes from "prop-types";
import { TaskList } from "./TaskList.js";

const WIDTH = 350;

const TaskMenuSelector = ({ className, onTaskSelect, projectId }) => {
  const [selectedTaskId, setSelectedTaskId] = useState();
  const [height, setHeight] = useState(72);

  const handleSetTask = useCallback(
    (id) => {
      setSelectedTaskId(id);
      onTaskSelect(id);
    },
    [setSelectedTaskId, onTaskSelect]
  );

  const handleHeight = useCallback((element) => {
    setHeight(element?.offsetHeight ? element.offsetHeight : 0);
  }, []);

  return (
    <Paper
      type="paper-2"
      className={classnames("project_task_menu_selector tw-absolute tw-overflow-hidden", className)}
    >
      <ResizeTransition
        in
        onEnter={handleHeight}
      >
        <div style={{ height, width: WIDTH }}>
          <MoveFocusInside>
            <TaskList
              projectId={projectId}
              selectedId={selectedTaskId}
              onChange={handleSetTask}
              onHeightChange={setHeight}
              style={{ width: WIDTH }}
              changeHeight
              focusInput
            />
          </MoveFocusInside>
        </div>
      </ResizeTransition>
    </Paper>
  );
};

TaskMenuSelector.propTypes = {
  className: PropTypes.string,
  onTaskSelect: PropTypes.func,
  onClose: PropTypes.func,
  projectId: PropTypes.number.isRequired,
};

TaskMenuSelector.defaultProps = {
  onTaskSelect: () => null,
  onClose: () => null,
};

TaskMenuSelector.displayName = "TaskMenuSelector";

export default TaskMenuSelector;
